import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import PlantillaModal from '../util/PlantillaModal';
import instanciaAxios from '../../miscelaneo/instanciaAxios';
import { useImpresion } from '../../contexts/ContextoImpresion';

export default function ModalRetiroCaja({ mostrar, onClose, onRetiroCreado }) {
  const { imprimirDocumento } = useImpresion();
  const [monto, setMonto] = useState('');
  const [motivo, setMotivo] = useState('');
  const [idCuentaDestino, setIdCuentaDestino] = useState('');
  const [cuentasDestino, setCuentasDestino] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [cargandoCuentas, setCargandoCuentas] = useState(false);
  const montoRef = useRef(null);

  useEffect(() => {
    if (mostrar) {
      cargarCuentasDestino();
      setMonto('');
      setMotivo('');
      setIdCuentaDestino('');
      setTimeout(() => montoRef.current?.focus(), 200);
    }
  }, [mostrar]);

  const cargarCuentasDestino = async () => {
    try {
      setCargandoCuentas(true);
      const response = await instanciaAxios.get('/retiro-caja/cuentas-destino');
      setCuentasDestino(response.data);
      if (response.data.length === 1) {
        setIdCuentaDestino(String(response.data[0].id_cuenta_tesoreria));
      }
    } catch (error) {
      console.error('Error al cargar cuentas destino:', error);
      toast.error('Error al cargar cuentas destino');
    } finally {
      setCargandoCuentas(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const montoNum = parseFloat(monto);
    if (!montoNum || montoNum <= 0) {
      toast.warning('Ingrese un monto válido mayor a 0');
      return;
    }
    if (!idCuentaDestino) {
      toast.warning('Seleccione una cuenta destino');
      return;
    }

    try {
      setCargando(true);
      const response = await instanciaAxios.post('/retiro-caja', {
        monto: montoNum,
        motivo: motivo.trim() || null,
        id_cuenta_tesoreria_destino: parseInt(idCuentaDestino)
      });
      toast.success(response.data.mensaje);
      onRetiroCreado?.();
      onClose();

      try {
        await imprimirDocumento({
          idDocumento: response.data.retiro.id_retiro_caja,
          tipoDocumento: 'retiro_caja',
          formato: 'continuo'
        });
      } catch (printErr) {
        console.warn('No se pudo imprimir recibo de retiro:', printErr?.message);
      }
    } catch (error) {
      const msg = error.response?.data?.mensaje || 'Error al registrar retiro';
      toast.error(msg);
    } finally {
      setCargando(false);
    }
  };

  return (
    <PlantillaModal mostrar={mostrar} onClose={onClose} titulo="Retiro de Caja" maxWidth="max-w-md">
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        {/* Cuenta destino */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cuenta Destino</label>
          {cargandoCuentas ? (
            <p className="text-sm text-gray-400">Cargando cuentas...</p>
          ) : cuentasDestino.length === 0 ? (
            <p className="text-sm text-red-500">No hay cuentas destino configuradas. Cree una cuenta de tipo Efectivo que no sea caja.</p>
          ) : (
            <select
              value={idCuentaDestino}
              onChange={(e) => setIdCuentaDestino(e.target.value)}
              className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-color-primario"
              required
            >
              <option value="">Seleccione destino...</option>
              {cuentasDestino.map(c => (
                <option key={c.id_cuenta_tesoreria} value={c.id_cuenta_tesoreria}>
                  {c.descripcion}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* Monto */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Monto (RD$)</label>
          <input
            ref={montoRef}
            type="number"
            step="0.01"
            min="0.01"
            value={monto}
            onChange={(e) => setMonto(e.target.value)}
            placeholder="0.00"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-color-primario"
            required
          />
        </div>

        {/* Motivo */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Motivo (opcional)</label>
          <input
            type="text"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Ej: Resguardo de seguridad"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-color-primario"
          />
        </div>

        {/* Botones */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={cargando || cuentasDestino.length === 0}
            className="flex-1 px-4 py-2.5 bg-color-primario text-white rounded-xl text-sm font-medium hover:bg-color-secundario transition-colors disabled:opacity-50"
          >
            {cargando ? 'Registrando...' : 'Registrar Retiro'}
          </button>
        </div>
      </form>
    </PlantillaModal>
  );
}
